import React from 'react'
import { AppContext } from '../../App'
import * as Request from '../../utilities/request'
import { TeamTimesheet, Utilisation } from '../../../../back-end/common/billyDashboard'
import DashboardCard, { HeaderBr } from './dashboardCard'
import { Loading } from '../ui/Loading/Loading'
import { Col, Row } from 'react-bootstrap'
import { roundToTwo } from '../../utilities/format'
import { TestingStaff } from '../../screens/dashboard/dashboardWrapper'

const missingHours = (util: Utilisation | null) => (util ? util.standardWorkingHoursPeriodTotal - util.billableHours - util.nonBillableHours : 0)
const recentUtilMissingHours = (recentUtil: { weekPeriod: Utilisation | null; monthPeriod: Utilisation | null }) =>
	roundToTwo(missingHours(recentUtil.monthPeriod))
const timesheetSort = (a: TeamTimesheet, b: TeamTimesheet) => {
	if (!a.recentUtilisation && !b.recentUtilisation) {
		return a.staffName < b.staffName ? -1 : 1
	}
	if (!a.recentUtilisation) {
		return 1
	}
	if (!b.recentUtilisation) {
		return -1
	}
	return recentUtilMissingHours(b.recentUtilisation) - recentUtilMissingHours(a.recentUtilisation)
}

interface TeamTimesheetsProps {
	firmView: boolean
	testingStaff?: TestingStaff
	onEADashboard?: boolean
}

const TeamTimesheets = (props: TeamTimesheetsProps) => {
	const { appState } = React.useContext(AppContext)

	const [teamTimesheets, setTeamTimesheets] = React.useState<TeamTimesheet[] | null>(null)
	const [errorMsg, setErrorMsg] = React.useState<string | null>(null)

	React.useEffect(() => {
		const getData = async () => {
			const testingStaffXpmID = props.testingStaff ? '/' + props.testingStaff.xpmID : ''
			const teamTimesheetRes = await Request.get(`billydashboard/teamtimes${testingStaffXpmID}?firm=${props.firmView}`)

			setTeamTimesheets(teamTimesheetRes.data.teamTimesheets)

			if (!teamTimesheetRes.data.success) {
				setErrorMsg(teamTimesheetRes.data.message)
			}
		}

		setTeamTimesheets(null)
		setErrorMsg(null)
		if (appState.authState.isLoggedIn) {
			getData()
		}
	}, [appState.authState, props])

	if (props.onEADashboard && !props.testingStaff) {
		return (
			<DashboardCard background="cornflower">
				<div className="center-flex p-3">
					<span className="span-body-2 span-black">Select a Director to view timesheets</span>
				</div>
			</DashboardCard>
		)
	}

	if (errorMsg) {
		return (
			<DashboardCard background="cornflower">
				<div className="center-flex p-3">
					<span className="span-body-2 span-black">{errorMsg}</span>
				</div>
			</DashboardCard>
		)
	}

	if (!teamTimesheets) {
		return (
			<DashboardCard background="cornflower">
				<div className="center-flex">
					<Loading show />
				</div>
			</DashboardCard>
		)
	}

	const colWidths = {
		name: 4,
		missing: 2,
		current: 3,
		prev: 3,
	}

	return (
		<DashboardCard background="cornflower">
			<Row className="pb-2">
				<Col>
					<span className="span-body-2 span-bold span-black">Team Timesheets{teamTimesheets.length > 20 ? ' - Top 20' : ''}</span>
				</Col>
			</Row>
			<Row className="pb-2">
				<Col sm={colWidths.name + colWidths.missing} className="d-flex justify-content-end">
					<span className="span-body-2 span-bold span-black">Missing Hrs</span>
				</Col>
				<Col sm={colWidths.current} className="d-flex justify-content-end">
					<span className="span-body-2 span-bold span-black">Last Week</span>
				</Col>
				<Col sm={colWidths.prev} className="d-flex justify-content-end">
					<span className="span-body-2 span-bold span-black">This Month</span>
				</Col>
			</Row>
			<Row className="pb-2">
				<Col sm={colWidths.name + colWidths.missing} className="d-flex justify-content-end"></Col>
				<Col sm={colWidths.current} className="d-flex justify-content-end">
					<span className="span-body-2 span-bold span-black">Utilisation</span>
				</Col>
				<Col sm={colWidths.prev} className="d-flex justify-content-end">
					<span className="span-body-2 span-bold span-black">Utilisation</span>
				</Col>
			</Row>
			<HeaderBr color="black" />
			{teamTimesheets
				.sort(timesheetSort)
				.slice(0, 20)
				.map((timesheet, index) => (
					<Row key={index} className="py-2">
						<Col sm={colWidths.name}>
							<span className="span-body-2 span-black">{timesheet.staffName}</span>
						</Col>
						{timesheet.recentUtilisation ? (
							<>
								<Col sm={colWidths.missing} className="d-flex justify-content-end">
									<span className="span-body-2 span-black text-nowrap">{recentUtilMissingHours(timesheet.recentUtilisation)} hrs</span>
								</Col>
								<Col sm={colWidths.current} className="d-flex justify-content-end">
									<span className="span-body-2 span-black">{timesheet.recentUtilisation.weekPeriod?.percentUtilised || 0}%</span>
								</Col>
								<Col sm={colWidths.prev} className="d-flex justify-content-end">
									<span className="span-body-2 span-black">{timesheet.recentUtilisation.monthPeriod?.percentUtilised || 0}%</span>
								</Col>
							</>
						) : (
							<Col sm={12 - colWidths.name} className="d-flex justify-content-center">
								<span className="span-body-2 span-black">Standard Working Hours not set</span>
							</Col>
						)}
					</Row>
				))}
		</DashboardCard>
	)
}

export default TeamTimesheets
